export default {
  api: {
    base: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8989/api'
  },
  telegram: {
    bot: process.env.REACT_APP_TELEGRAM_BOT || 'Thrift_dev_bot'
  }
}
